{
  "familyId": "TIJD-CONVERSIE",
  "questions": [
    {
      "id": "TIJD-CONVERSIE-001",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "Op de analoge klok is het kwart over 3. Hoe schrijf je dit digitaal?",
      "options": ["15:15", "03:15", "15:45", "03:45"],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_quarter_afternoon",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [
        { "id": "tijd.12-uur-vergeten", "label": "Vergeet 12 uur bij te tellen voor 's middags", "optionIndex": 1 },
        { "id": "tijd.kwart-over-voor-verwisseld", "label": "Verwart kwart over (:15) met kwart voor (:45)", "optionIndex": 2 },
        { "id": "tijd.dubbele-fout-12-en-kwart", "label": "Vergeet 12 uur én verwart kwart over/voor", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "clock", "data": { "hours": 15, "minutes": 15 } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Analoog naar digitaal 's middags", "content": "Kwart over 3 's middags = 3:15 + 12 uur = 15:15. Bij tijden 's middags tel je altijd 12 uur bij het gewone uur. Kwart over betekent :15." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Bij tijden 's middags tel je 12 uur bij het gewone uur, en vertaal je 'kwart over' naar :15. Het uur is 3 + 12 = 15. Kwart over = :15. Dus het antwoord is 15:15.",
        "solutionSteps": ["Kwart over 3 's middags → uur = 3 + 12 = 15", "Kwart over = :15", "Antwoord = 15:15"],
        "distractorExplanations": {
          "0": "Goed! Kwart over 3 's middags = 3 + 12 = 15, en kwart over = :15, dus 15:15.",
          "1": "Je dacht waarschijnlijk dat je geen 12 uur hoeft bij te tellen. Maar 03:15 is kwart over 3 's ochtends. Voor 's middags: 3 + 12 = 15, dus 15:15.",
          "2": "Je dacht waarschijnlijk dat kwart over hetzelfde is als kwart voor. Maar kwart over = :15 (15 minuten na het hele uur). Kwart voor = :45 (15 minuten vóór het volgende uur). 15:45 is kwart voor 4.",
          "3": "Je dacht waarschijnlijk dat je geen 12 hoeft bij te tellen én verwarde kwart over met kwart voor. 03:45 = kwart voor 4 's ochtends. Kwart over 3 's middags = 15:15."
        }
      }
    },
    {
      "id": "TIJD-CONVERSIE-002",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "De digitale klok toont 19:30. Hoe laat is het op een analoge klok?",
      "options": ["half 8 's avonds", "half 7 's avonds", "half 8 's ochtends", "8 uur 's avonds"],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_half_evening",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1, "misconceptionTags": [
        { "id": "tijd.half-verkeerd-uur", "label": "Koppelt 'half' aan het huidige uur i.p.v. het volgende", "optionIndex": 1 },
        { "id": "tijd.pm-als-am", "label": "Verwart 's avonds met 's ochtends bij 24-uursklok", "optionIndex": 2 },
        { "id": "tijd.minuten-genegeerd", "label": "Negeert de minuten en leest alleen het uur", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 19, "minutes": 30 } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Digitaal naar analoog 's avonds", "content": "19:30 betekent 19 - 12 = 7:30. Bij :30 (half) kijk je naar het volgende uur. 7:30 = half 8 's avonds. Trek altijd 12 af van tijden boven 12:00." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Trek 12 af van tijden boven 12:00 en vertaal de minuten naar 'half/kwart'. 19 − 12 = 7, dus het is 7 uur 's avonds. :30 = half uur. Bij 'half' kijk je naar het volgende uur: 7:30 = half 8 's avonds.",
        "solutionSteps": ["19 − 12 = 7 → 7 uur 's avonds", ":30 = half uur", "Bij 'half' kijk je naar het volgende uur: 7:30 = half 8", "19:30 = half 8 's avonds"],
        "distractorExplanations": {
          "0": "Goed! 19:30 = 19 − 12 = 7:30, en bij 'half' kijk je naar het volgende uur, dus half 8 's avonds.",
          "1": "Je dacht waarschijnlijk dat 'half' naar het huidige uur verwijst. Maar bij 'half' kijk je naar het volgende uur, niet het huidige. 7:30 = half 8 (een half uur vóór 8), niet half 7.",
          "2": "Je dacht waarschijnlijk dat 19:30 's ochtends is. Maar tijden boven 12:00 zijn altijd 's middags of 's avonds. 19:30 = 7:30 's avonds, niet 's ochtends.",
          "3": "Je dacht waarschijnlijk dat je de minuten kunt negeren. Maar :30 betekent half uur (30 minuten). 19:30 is niet 8 uur precies, maar half 8 's avonds."
        }
      }
    },
    {
      "id": "TIJD-CONVERSIE-003",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "Op de analoge klok is het 10 over 9 's ochtends. Hoe schrijf je dit digitaal?",
      "options": ["09:10", "21:10", "09:50", "10:09"],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_minutes_morning",
      "variantIndex": 3,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 1, "misconceptionTags": [
        { "id": "tijd.12-uur-onnodig-bijtellen", "label": "Telt 12 uur bij terwijl het 's ochtends is", "optionIndex": 1 },
        { "id": "tijd.over-voor-verwisseld", "label": "Verwart 'over' met 'voor' (10 over → :50 i.p.v. :10)", "optionIndex": 2 },
        { "id": "tijd.uur-minuten-omgedraaid", "label": "Draait uur en minuten om in digitale notatie", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "clock", "data": { "hours": 9, "minutes": 10 } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Minuten omzetten 's ochtends", "content": "10 over 9 's ochtends = 9:10. 's Ochtends hoef je geen 12 bij te tellen. Schrijf het uur eerst (09), dan de minuten (:10)." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Schrijf het uur eerst, dan de minuten. 's Ochtends hoef je geen 12 bij te tellen. Het uur is 9 → schrijf 09. 10 over = 10 minuten → schrijf :10. Dus het antwoord is 09:10.",
        "solutionSteps": ["Het uur is 9 → schrijf 09", "10 over = 10 minuten → schrijf :10", "Antwoord = 09:10"],
        "distractorExplanations": {
          "0": "Goed! 10 over 9 's ochtends = 09:10 (uur eerst, dan minuten).",
          "1": "Je dacht waarschijnlijk dat je 12 uur moet bijtellen. Maar 21:10 = 9:10 's avonds. De vraag gaat over 's ochtends, dus 09:10.",
          "2": "Je dacht waarschijnlijk dat 'over' hetzelfde is als 'voor'. Maar 10 over = :10 (10 minuten ná het hele uur). 09:50 = 10 voor 10 (10 minuten vóór het volgende uur).",
          "3": "Je dacht waarschijnlijk dat je uur en minuten omdraait. Maar digitaal schrijf je altijd eerst het uur, dan de minuten: 09:10, niet 10:09."
        }
      }
    },
    {
      "id": "TIJD-CONVERSIE-004",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "De digitale klok toont 16:45. Hoe laat is het op een analoge klok?",
      "options": ["kwart voor 5 's middags", "kwart over 4 's middags", "kwart voor 4 's middags", "kwart over 5 's middags"],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_quarter_to",
      "variantIndex": 4,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 16, "minutes": 45 } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Kwart voor omzetten", "content": "16:45 betekent 16 - 12 = 4:45. Bij :45 (kwart voor) kijk je naar het volgende uur. 4:45 = kwart voor 5 's middags." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Trek 12 af van tijden boven 12:00 en vertaal :45 naar 'kwart voor'. 16 − 12 = 4, dus het is 4 uur 's middags. :45 = kwart voor. Bij 'kwart voor' kijk je naar het volgende uur: 4:45 = kwart voor 5 's middags.",
        "solutionSteps": ["16 − 12 = 4 → 4 uur 's middags", ":45 = kwart voor", "Bij 'kwart voor' kijk je naar het volgende uur: 4:45 = kwart voor 5", "16:45 = kwart voor 5 's middags"],
        "distractorExplanations": {
          "0": "Goed! 16:45 = 4:45 's middags = kwart voor 5 's middags.",
          "1": "Je dacht waarschijnlijk dat kwart over en kwart voor hetzelfde zijn. Maar :45 = kwart voor (45 minuten), :15 = kwart over (15 minuten). 16:45 is kwart voor 5, niet kwart over 4.",
          "2": "Je dacht waarschijnlijk dat 'kwart voor' naar het huidige uur verwijst. Maar bij 'kwart voor' kijk je naar het volgende uur. 4:45 = kwart voor 5, niet kwart voor 4.",
          "3": "Je dacht waarschijnlijk dat :45 kwart over het volgende uur is. Maar :45 = kwart voor het volgende uur, :15 = kwart over het huidige uur. 16:45 = kwart voor 5, niet kwart over 5."
        }
      }
    },
    {
      "id": "TIJD-CONVERSIE-005",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "Op de analoge klok is het 5 voor half 7 's avonds. Hoe schrijf je dit digitaal?",
      "options": ["18:25", "18:35", "06:25", "19:25"],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_before_half",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "clock", "data": { "hours": 18, "minutes": 25 } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Voor half omrekenen", "content": "Half 7 = 6:30. Vijf voor half 7 = 6:30 - 5 minuten = 6:25. 's Avonds tel je 12 bij: 6 + 12 = 18. Dus 18:25." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Vertaal 'voor half' stap voor stap. Half 7 = 6:30. Vijf voor half 7 = 6:30 − 5 minuten = 6:25. 's Avonds tel je 12 bij: 6 + 12 = 18. Dus het antwoord is 18:25.",
        "solutionSteps": ["Half 7 = 6:30", "Vijf voor half 7 = 6:30 − 5 minuten = 6:25", "'s Avonds tel je 12 bij: 6 + 12 = 18", "Antwoord = 18:25"],
        "distractorExplanations": {
          "0": "Goed! Half 7 = 6:30, vijf voor = −5 minuten = 6:25, en 's avonds + 12 = 18:25.",
          "1": "Je dacht waarschijnlijk dat 'voor' en 'over' half hetzelfde zijn. Maar 5 voor half = 5 minuten eerder dan half (6:30 − 5 = 6:25). 5 over half = 5 minuten later (6:30 + 5 = 6:35).",
          "2": "Je dacht waarschijnlijk dat je geen 12 hoeft bij te tellen voor 's avonds. Maar 06:25 is 's ochtends. Voor 's avonds: 6 + 12 = 18, dus 18:25.",
          "3": "Je dacht waarschijnlijk dat 'half 7' hetzelfde is als 7:30. Maar half 7 = 6:30 (een half uur vóór 7), niet 7:30. Vijf voor half 7 = 6:25, niet 7:25. 's Avonds: 18:25."
        }
      }
    },
    {
      "id": "TIJD-CONVERSIE-006",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "De digitale klok toont 11:20. Hoe laat is het op een analoge klok?",
      "options": ["20 over 11", "20 voor 12", "half 12", "11 uur 's avonds"],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_twenty",
      "variantIndex": 6,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 11, "minutes": 20 } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Minuten aflezen", "content": "11:20 betekent 11 uur en 20 minuten. Dat zeg je als '20 over 11'. 20 over = 20 minuten ná het hele uur." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Vertaal de digitale tijd naar woorden. 11:20 = 11 uur en 20 minuten. 20 minuten na het hele uur = '20 over 11'. Dit is de meest directe vertaling van de digitale tijd.",
        "solutionSteps": ["11:20 = 11 uur en 20 minuten", "20 minuten na het hele uur = '20 over 11'", "Controleer: 11 uur + 20 minuten = 11:20 ✓"],
        "distractorExplanations": {
          "0": "Goed! 11:20 = 20 over 11 (11 uur en 20 minuten).",
          "1": "Je dacht waarschijnlijk dat 'over' hetzelfde is als 'voor'. Maar 20 voor 12 = 11:40 (12:00 − 20 minuten). 11:20 = 20 over 11 (11:00 + 20 minuten). Onthoud: 'over' = minuten ná het uur, 'voor' = minuten vóór het volgende uur.",
          "2": "Je dacht waarschijnlijk dat 11:20 dicht genoeg bij half 12 is. Maar half 12 = 11:30, en 11:20 is 10 minuten eerder. Onthoud: half = :30, niet :20.",
          "3": "Je dacht waarschijnlijk dat je de minuten kunt negeren. Maar :20 betekent 20 minuten na het hele uur. 11:20 is niet 11 uur precies — er staan 20 minuten achter de dubbele punt."
        }
      }
    },
    {
      "id": "TIJD-CONVERSIE-007",
      "familyId": "TIJD-CONVERSIE",
      "module": "Tijd",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "matching",
      "question": "Koppel de analoge tijden aan de digitale tijden.",
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Half drie 's middags", "right": "14:30" },
          { "left": "Kwart over twee 's middags", "right": "14:15" },
          { "left": "Kwart voor drie 's middags", "right": "14:45" },
          { "left": "Drie uur 's middags", "right": "15:00" }
        ]
      },
      "conceptId": "time_analog_digital_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Tijden koppelen", "content": "Bij tijden 's middags tel je 12 bij het uur: half drie = 2:30 + 12 = 14:30, kwart over twee = 2:15 + 12 = 14:15, kwart voor drie = 2:45 + 12 = 14:45, drie uur = 3:00 + 12 = 15:00.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Bij tijden 's middags tel je 12 bij het gewone uur, en vertaal je 'half/kwart' naar minuten. Half drie = 2:30 → 14:30. Kwart over twee = 2:15 → 14:15. Kwart voor drie = 2:45 → 14:45. Drie uur = 3:00 → 15:00.",
        "solutionSteps": ["Half drie 's middags = 2:30 + 12 = 14:30", "Kwart over twee 's middags = 2:15 + 12 = 14:15", "Kwart voor drie 's middags = 2:45 + 12 = 14:45", "Drie uur 's middags = 3:00 + 12 = 15:00"]
      }
    }
  ]
}